<template lang="pug">
section.rules
  h2.rules__title {{ $t("promo.rules.title") }}
  .rules__wrap
    .rules__text
      p {{ $t("promo.rules.text") }}
      ul
        li(v-for="(text, text_id) in $t('promo.rules.list')", :key="text_id") {{ text }}
</template>

<script>
export default {
  name: "Rules",
};
</script>
